import React from 'react';
import '../../component-styles/TimeRangePicker.css';

function to12Hour(time24) {
  if (!time24) return { hour: '09', minute: '00', ampm: 'AM' };
  let [h, m] = time24.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return {
    hour: String(h).padStart(2, '0'),
    minute: String(m).padStart(2, '0'),
    ampm,
  };
}

function to24Hour(hour, minute, ampm) {
  let h = parseInt(hour, 10);
  if (ampm === 'PM' && h < 12) h += 12;
  if (ampm === 'AM' && h === 12) h = 0;
  return `${String(h).padStart(2, '0')}:${minute}`;
}

export default function TimeRangePicker({ start, end, onChangeStart, onChangeEnd }) {
  const startObj = to12Hour(start);
  const endObj = to12Hour(end);

  const handleStartChange = (field, val) => {
    const updated = {
      hour: field === 'hour' ? val : startObj.hour,
      minute: field === 'minute' ? val : startObj.minute,
      ampm: field === 'ampm' ? val : startObj.ampm,
    };
    onChangeStart(to24Hour(updated.hour, updated.minute, updated.ampm));
  };

  const handleEndChange = (field, val) => {
    const updated = {
      hour: field === 'hour' ? val : endObj.hour,
      minute: field === 'minute' ? val : endObj.minute,
      ampm: field === 'ampm' ? val : endObj.ampm,
    };
    onChangeEnd(to24Hour(updated.hour, updated.minute, updated.ampm));
  };

  return (
    <div className="gc-time-container">
      {/* Start Time */}
      <div className="gc-time-field">
        <input
          type="number"
          min="1"
          max="12"
          value={parseInt(startObj.hour, 10)}
          onChange={(e) => handleStartChange('hour', e.target.value.padStart(2, '0'))}
        />
        <span>:</span>
        <input
          type="number"
          min="0"
          max="59"
          step="5"
          value={startObj.minute}
          onChange={(e) => handleStartChange('minute', e.target.value.padStart(2, '0'))}
        />
        <button
          className="gc-ampm"
          onClick={() => handleStartChange('ampm', startObj.ampm === 'AM' ? 'PM' : 'AM')}
        >
          {startObj.ampm}
        </button>
      </div>

      <span className="gc-dash">–</span>

      {/* End Time */}
      <div className="gc-time-field">
        <input
          type="number"
          min="1"
          max="12"
          value={parseInt(endObj.hour, 10)}
          onChange={(e) => handleEndChange('hour', e.target.value.padStart(2, '0'))}
        />
        <span>:</span>
        <input
          type="number"
          min="0"
          max="59"
          step="5"
          value={endObj.minute}
          onChange={(e) => handleEndChange('minute', e.target.value.padStart(2, '0'))}
        />
        <button
          className="gc-ampm"
          onClick={() => handleEndChange('ampm', endObj.ampm === 'AM' ? 'PM' : 'AM')}
        >
          {endObj.ampm}
        </button>
      </div>
    </div>
  );
}
